import { borderosRoutes } from './borderos/rotas';

const routes = {
    path: 'autorizadorfinanceiro',
    name: 'Autorizador_Financeiro',
    component: () => import('./AutorizadorView.vue'),
    metas: {
        rules: [...borderosRoutes.meta.rules],
    },
    children: [borderosRoutes],
};

export default routes;
